// extracted by mini-css-extract-plugin
module.exports = {"editorBox":"EditorBox_editorBox__3zQc6","slideList":"EditorBox_slideList__vL49r","layout":"EditorBox_layout__30XtJ"};